import { apiClient } from "./client";

export interface BlogPost {
  _id: string;
  title: string;
  slug: string;
  content: string;
  excerpt?: string;
  published_date: string;
  author?: string;
  meta_description?: string;
  meta_keywords?: string;
  topic?: string;
  tone?: string;
  template?: string;
  length?: number;
  featured_listings_ids?: string[];
  product_schema?: Record<string, unknown>;
}

export interface BlogPostsResponse {
  posts: BlogPost[];
  total: number;
}

class BlogService {
  /**
   * Get paginated blog posts
   */
  async getPosts(
    skip: number = 0,
    limit: number = 10
  ): Promise<BlogPostsResponse> {
    return await apiClient.get<BlogPostsResponse>("/blog/posts", { skip, limit });
  }

  /**
   * Get a single blog post by slug
   */
  async getPostBySlug(slug: string): Promise<BlogPost> {
    return await apiClient.get<BlogPost>(`/blog/posts/${slug}`);
  }

  /**
   * Get featured blog posts
   */
  async getFeaturedPosts(limit: number = 3): Promise<BlogPost[]> {
    return await apiClient.get<BlogPost[]>("/blog/featured", { limit });
  }
}

export const blogService = new BlogService();
